import { render } from "./industryTemplate.vue?vue&type=template&id=70320640&scoped=true"
import script from "./industryTemplate.vue?vue&type=script&lang=js"
export * from "./industryTemplate.vue?vue&type=script&lang=js"

import "./industryTemplate.vue?vue&type=style&index=0&id=70320640&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70320640"

export default script